export default __webpack_public_path__ + "static/media/euscoastThumb.54188f7c.jpg";